// 这里放置一些工具函数（类）及业务处理逻辑
import * as errorHandler from './errorHandler'

export default {
  ...errorHandler
}
